import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
const COLORS = [
    'rgb(28, 176, 246)', // brand blue
    'rgb(24, 153, 214)',
    'rgb(63, 133, 167)',
    'rgb(88, 204, 2)', // green
    'rgb(255, 199, 0)', // yellow
    'rgb(255, 140, 0)', // orange
    'rgb(255, 134, 208)', // pink
    'rgb(155, 89, 230)', // purple
];
/**
 * Tiny confetti burst with no canvas and no dependency: divs animated via
 * CSS custom properties. Cleans itself up after ~1.6s. Re-runs when
 * `trigger` changes.
 */
export function Confetti({ trigger, count = 40 }) {
    const [visible, setVisible] = useState(false);
    const [pieces, setPieces] = useState([]);
    // Regenerate pieces when trigger changes
    useMemo(() => {
        if (trigger === 0 || trigger === '')
            return;
        const next = [];
        for (let i = 0; i < count; i += 1) {
            const shape = ['square', 'circle', 'strip'][Math.floor(Math.random() * 3)];
            next.push({
                id: i,
                left: 50 + (Math.random() - 0.5) * 40, // center ±20%
                delay: Math.random() * 120,
                duration: 1100 + Math.random() * 700,
                rotation: (Math.random() - 0.5) * 720,
                tx: (Math.random() - 0.5) * 460,
                color: COLORS[Math.floor(Math.random() * COLORS.length)],
                shape,
                size: shape === 'strip' ? 10 + Math.random() * 4 : 7 + Math.random() * 5,
            });
        }
        setPieces(next);
        setVisible(true);
    }, [trigger, count]);
    useEffect(() => {
        if (!visible)
            return;
        const t = setTimeout(() => setVisible(false), 1800);
        return () => clearTimeout(t);
    }, [visible, trigger]);
    if (!visible || pieces.length === 0)
        return null;
    return (_jsx("div", { className: "sl-confetti", "aria-hidden": true, children: pieces.map((p) => {
            const style = {
                left: `${p.left}%`,
                backgroundColor: p.color,
                width: p.shape === 'strip' ? 4 : p.size,
                height: p.shape === 'strip' ? p.size * 2 : p.size,
                borderRadius: p.shape === 'circle' ? '50%' : p.shape === 'strip' ? 2 : 2,
                animationDelay: `${p.delay}ms`,
                animationDuration: `${p.duration}ms`,
                ['--sl-cf-tx']: `${p.tx}px`,
                ['--sl-cf-rot']: `${p.rotation}deg`,
            };
            return _jsx("span", { className: "sl-confetti__piece", style: style }, p.id);
        }) }));
}
//# sourceMappingURL=Confetti.js.map